$('iframe').each(function(index, el) {
	var w = this.offsetWidth;
	var h = this.offsetHeight;
	var scale = (h / w) * 100;
	var p = $(this).parents('.embed-responsive');

	if(p.length == 0) {

		var embedResponsive = '<div class="embed-responsive" id="embed-'+index+'" style="width: 100%;max-width: '+w+'px">'+
			'<div class="embed-responsive-content" style="Padding-bottom: '+scale+'%"></div>'+
		'</div>';

		
		$(this).after(embedResponsive);

		var c = document.querySelector('#embed-'+index+' .embed-responsive-content');

		if(c) {
			c.appendChild(this);
		}
	}
})